import { AnomalieType } from '../../types/theme';
import { SET_THEME_DATA, ThemeActionTypes } from '../actions/theme.action';

export type ThemeState = {
  [key: string]: {
    anomalyTypes: AnomalieType[];
    reports: any[];
    maxPages: number;
    pageNumber: number;
    maxResultPage: number;
    sumUnreadReports: number;
  };
};

const initialState: ThemeState = {};

export const themeReducer = (state = initialState, action: ThemeActionTypes) => {
  switch (action.type) {
    case SET_THEME_DATA: {
      const { themeShortCode, data } = action.payload;
      const themeData = state[themeShortCode] || {};

      return {
        ...state,
        [themeShortCode]: {
          ...themeData,
          ...data,
        },
      };
    }

    default:
      return state;
  }
};

export default themeReducer;
